// extracted by css-extract-rspack-plugin
export default {"container":"PinnedIssues-module__container__rDfnufJ","area":"PinnedIssues-module__area__ulv7DUc"};